import { LogData } from '~/interfaces/log.interface';

export function newHumanReadableLog(log: LogData) {
    switch (log.method) {
        case 'Modify_Group':
            return `Switch "${log.params.device_id}" to device group "${log.params.new_group_name}"`;
        case 'Reset_Device':
            return `Reset "${log.params.device_id}"`;
        case 'Order_Device_Reboot':
            return `Reboot "${log.params.device_id}"`;
        case 'admin_device_reset_abc':
            return `Recalibrate CO2 "${log.params.device_id}"`;
        case 'Delete_Device_Cache':
            return `Delete "${log.params.device_id}" cache`;
        case 'Delete_Phantoms':
            return `Delete phantoms
                    from ${log.info ? log.info.home_name : ''} ${!log.info || !log.info.home_name ? 'home_id ' + log.params.home_id : ''}`;
        case 'Dissociate_Module':
            return `Dissociate module "${log.params.module_id}" from "${log.params.device_id}"`;
        case 'Set_Data_Offset':
            return `Set ${log.params.data_type} offset of module "${log.params.module_id}" from "${log.params.device_id}" to ${log.params.offset}`;
        case 'Send_Vpn_Command':
            return `Send command ${log.params.command} to "${log.params.camera_id}"`;
        case 'Modify_Device_Behavior':
            return `
                Set "${log.params.device_id}" behavior to
                Led disabled: ${log.params.led_disabled}
                | Touch disabled: ${log.params.touch_disabled}
                | Relay polarity inverted: ${log.params.relay_polarity_inverted}
                | RF statistic enable: ${log.params.rf_statistics_enabled}
                Modified RF cycle duration: ${log.params.modified_rf_cycle_duration}
                ${log.params.usb_host_disabled ? '| USB host disabled: ' + log.params.usb_host_disabled : ''}
                ${log.params.legacy_offset ? '| New humidity coefficients: ' + log.params.legacy_offset : ''}
            `;
        case 'Migrate_Data_2':
            return `
                Migrate records from "${log.params.old_device_id}" to "${log.params.old_device_id}"
                ${log.params.new_module_id && log.params.old_module_id ?
        'and reassign records from module "' + log.params.old_module_id + '" to "' + log.params.new_module_id + '"'
        : ''
}
            `;
        case 'Generate_Qr_Code':
            return `
                Generate
                ${!log.params.cmd || log.params.cmd === 'START_INSTALL' ? 'install' : ''}
                ${log.params.cmd && log.params.cmd === 'RESET_HOMEKIT' ? 'reset' : ''}
                qrcode for camera "${log.params.camera_id}"
            `;
        case 'Change_Heating_Algo': {
            let algo = '';
            switch (log.params.algo_type) {
                case 'simple_algo':
                    algo = 'simple';
                    break;
                case 'pid_algo':
                    algo = 'PID';
                    break;
                default:
                    algo = 'UNKNOWN';
            }
            return `Update heating algo of "${log.params.device_id}" to algorithm ${algo} with params ${JSON.stringify(log.params.algo_params)}`;
        }
        case 'Delete_Account':
            return `Delete user account "${log.params.user_mail}"`;
        case 'admin_ask_plug_to_reconnect':
            return `Force main loop for gateway "${log.params.device_id}"`;
        case 'Toggle_Device_Dump':
            return `Toggle memory dump for device "${log.params.device_id}"`;
        case 'Set_Debug_Status':
            return `
                ${log.params.debug === true || log.params.debug === 'true' ? 'Set' : 'Unset'}
                debug status of device "${log.params.device_id}"
            `;

        default:
            return 'Log for action ' + log.method + ' not implemented yet';

    }
}

export function oldHumanReadableLog(log: LogData) {
    switch (log.method) {
        case 'admin_toggle_right':
            return `${log.params.action} right "${log.params.right}" to "${log.params.mail}"`;
        case 'admin_modify_group':
            return `Switch "${log.params.device_id}" to device group "${log.params.new_group_name}"`;
        case 'admin_reset_device':
            return `Reset "${log.params.device_id}"`;
        case 'admin_order_device_reboot':
            return `Reboot "${log.params.device_id}"`;
        case 'admin_device_reset_abc':
            return `Recalibrate CO2 "${log.params.device_id}"`;
        case 'admin_delete_device_cache':
            return `Delete "${log.params.device_id}" cache`;
        case 'admin_delete_phantoms':
            return `Delete phantoms
                    from ${log.info ? log.info.home_name : ''} ${!log.info || !log.info.home_name ? 'home_id ' + log.params.home_id : ''}`;
        case 'admin_dissociate_module':
            return `Dissociate module "${log.params.module_id}" from "${log.params.device_id}"`;
        case 'admin_set_data_offset':
            return `Set ${log.params.data_type} offset of module "${log.params.module_id}" from "${log.params.device_id}" to ${log.params.offset}`;
        case 'admin_send_vpn_command':
            return `Send command ${log.params.command} to "${log.params.camera_id}"`;
        case 'admin_modify_device_behavior':
            return `
                Set "${log.params.device_id}" behavior to
                Led disabled: ${log.params.led_disabled}
                | Touch disabled: ${log.params.touch_disabled}
                | Relay polarity inverted: ${log.params.relay_polarity_inverted}
                | RF statistic enable: ${log.params.rf_statistics_enabled}
                Modified RF cycle duration: ${log.params.modified_rf_cycle_duration}
                ${log.params.usb_host_disabled ? '| USB host disabled: ' + log.params.usb_host_disabled : ''}
                ${log.params.legacy_offset ? '| New humidity coefficients: ' + log.params.legacy_offset : ''}
            `;
        case 'admin_migrate_data':
            return `
                Migrate records from "${log.params.old_device_id}" to "${log.params.old_device_id}"
                ${log.params.new_module_id && log.params.old_module_id ?
        'and reassign records from module "' + log.params.old_module_id + '" to "' + log.params.new_module_id + '"'
        : ''
}
            `;
        case 'admin_generate_qrcode':
            return `
                Generate
                ${!log.params.cmd || log.params.cmd === 'START_INSTALL' ? 'install' : ''}
                ${log.params.cmd && log.params.cmd === 'RESET_HOMEKIT' ? 'reset' : ''}
                qrcode for camera "${log.params.camera_id}"
            `;
        case 'admin_change_heating_algo': {
            let algo = '';
            switch (log.params.algo_type) {
                case 'simple_algo':
                    algo = 'simple';
                    break;
                case 'pid_algo':
                    algo = 'PID';
                    break;
                default:
                    algo = 'UNKNOWN';
            }
            return `Update heating algo of "${log.params.device_id}" to algorithm ${algo} with params ${JSON.stringify(log.params.algo_params)}`;
        }
        case 'admin_delete_account':
            return `Delete user account "${log.params.user_mail}"`;
        case 'admin_ask_plug_to_reconnect':
            return `Force main loop for gateway "${log.params.device_id}"`;
        case 'admin_toggle_device_dump':
            return `Toggle memory dump for device "${log.params.device_id}"`;
        case 'admin_set_debug_status':
            return `
                ${log.params.debug === true || log.params.debug === 'true' ? 'Set' : 'Unset'}
                debug status of device "${log.params.device_id}"
            `;
        case 'admin_create_admin':
            return `Add admin "${log.params.admin_mail}" to group "${log.info ? log.info.group_name : ''}"`;
        case 'admin_remove_admin':
            return `Remove admin ${log.params.admin_mail} from group ${log.info ? log.info.group_name : ''}`;
        case 'admin_create_group':
            return `Create ${log.params.dev ? 'development' : ''} admin group ${log.params.name}`;
        case 'admin_delete_group':
            return `Delete admin group ${log.info.group_name}`;

        default:
            return 'Log for action ' + log.method + ' not implemented yet';

    }
}